// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'billing',
        component: () =>
            import('@/pages/[organisation]/settings/subscription-invoices/subscription-invoices.vue'),
        name: 'settings.subscription-invoices.billing',
        meta: {
            loginRequired: true,
            permission: 'access.saas.subscription-invoice.view-subscription-invoices',
        },
    },

    {
        path: 'billing/invoices',
        component: () =>
            import(/* webpackChunkName: "settings.billing" */ '@/pages/[organisation]/settings/subscription-invoices/subscription-invoices.vue'),
        name: 'settings.subscription-invoices.search-subscription-invoices',
        meta: {
            loginRequired: true,
            permission: 'access.saas.subscription-invoice.view-subscription-invoices',
        },
    },

    {
        path: 'billing/:id/invoice-payments',
        component: () =>
            import(/* webpackChunkName: "settings.billing" */ '@/pages/[organisation]/settings/subscription-invoice-payments/subscription-invoice-payments.vue'),
        name: 'settings.subscription-invoice-payments.search-invoice-payments',
        meta: {
            loginRequired: true,
            permission: 'access.saas.subscription-invoice.view-subscription-invoice-payments',
        },
    },
    {
        path: 'billing/update-payment-method',
        component: () =>
            import(/* webpackChunkName: "settings.billing" */ '@/pages/[organisation]/settings/subscription-invoices/payment-method/[id]/edit.vue'),
        name: 'settings.subscription-invoices.update-payment-method',
        meta: {
            loginRequired: true,
            permission: 'access.saas.subscription-invoice.update-saas-billing-method',
        },
    },
    {
        path: 'billing/:id',
        component: () =>
            import(/* webpackChunkName: "settings.billing" */ '@/pages/[organisation]/settings/subscription-invoices/subscription-invoice/[id].vue'),
        name: 'settings.subscription-invoices.view-subscription-invoice',
        meta: {
            loginRequired: true,
            permission: 'access.saas.subscription-invoice.view-subscription-invoices',
        },
    },
];
